import { useLocation, useNavigate } from 'react-router-dom';
import { useBaaSAuth } from '@/contexts/BaaSAuthContext';
import {
  LayoutDashboard, Users, Shield, Hash, AlertTriangle,
  Download, ClipboardCheck, Settings, ChevronRight, Banknote,
  Wrench, Terminal, Activity, Landmark, LifeBuoy, Receipt, UserPlus, Send, Scale,
} from 'lucide-react';
import { BaaSApiHealthBadge } from './BaaSApiHealthBadge';

const baasNav = [
  { label: 'Dashboard', icon: LayoutDashboard, path: '/baas' },
  { label: 'Customers', icon: Users, path: '/baas/customers' },
  { label: 'Onboard Client', icon: UserPlus, path: '/baas/customers/new' },
  { label: 'Payments', icon: Send, path: '/baas/payments' },
  { label: 'KYC Status', icon: Shield, path: '/baas/kyc' },
  { label: 'Accounts & IBANs', icon: Hash, path: '/baas/accounts' },
  
  { label: 'Safeguarding', icon: Landmark, path: '/baas/safeguarding' },
  { label: 'Alerts & Cases', icon: AlertTriangle, path: '/baas/alerts' },
  { label: 'Cases & Appeals', icon: Scale, path: '/baas/cases' },
  { label: 'Control Requests', icon: ClipboardCheck, path: '/baas/requests' },
  { label: 'Exports', icon: Download, path: '/baas/exports' },
  { label: 'Sandbox', icon: Terminal, path: '/baas/sandbox' },
  { label: 'API Status', icon: Activity, path: '/baas/status' },
  { label: 'Manual Ops', icon: Wrench, path: '/baas/manual-ops' },
  { label: 'Support', icon: LifeBuoy, path: '/baas/support' },
  { label: 'Billing', icon: Receipt, path: '/baas/billing' },
  { label: 'Audit Log', icon: ClipboardCheck, path: '/baas/audit' },
  { label: 'Settings', icon: Settings, path: '/baas/settings' },
];

export function BaaSSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { baasUser } = useBaaSAuth();

  const isActive = (path: string) =>
    path === '/baas' ? location.pathname === path : location.pathname.startsWith(path);

  return (
    <nav className="w-[220px] border-r border-border/60 bg-card/40 backdrop-blur-xl p-3 space-y-0.5 shrink-0 overflow-y-auto">
      <div className="px-2 pb-3 mb-2 border-b border-border/50">
        <p className="font-display text-[10px] font-bold text-muted-foreground uppercase tracking-[0.14em]">BaaS Partner</p>
        <div className="flex items-center gap-1.5 mt-1.5">
          <div className="w-5 h-5 rounded-md bg-gradient-accent shadow-glow-soft flex items-center justify-center">
            <Banknote className="w-3 h-3 text-accent-foreground" />
          </div>
          <span className="text-[11px] text-foreground font-semibold truncate">{baasUser?.partnerName}</span>
        </div>
        <div className="mt-2">
          <BaaSApiHealthBadge />
        </div>
      </div>
      {baasNav.map(item => {
        const active = isActive(item.path);
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm font-medium transition-all ${
              active
                ? 'bg-accent/15 text-[hsl(var(--accent))] shadow-glow-soft ring-1 ring-accent/20'
                : 'text-muted-foreground hover:text-foreground hover:bg-secondary/60'
            }`}
          >
            <item.icon className="w-4 h-4" />
            <span className="flex-1 text-left">{item.label}</span>
            {active && <ChevronRight className="w-3 h-3 opacity-50" />}
          </button>
        );
      })}
    </nav>
  );
}
